import { Toaster } from "sonner";
import { useWallet } from "@solana/wallet-adapter-react";
import Game from "../components/jetdog/Game";
import Leaderboard from "../components/jetdog/Leaderboard";

function LeaderboardWithWallet() {
  const { publicKey } = useWallet();
  return <Leaderboard currentWallet={publicKey ? publicKey.toBase58() : null} />;
}

export default function PlayPage() {
  return (
    <div className="min-h-screen bg-[var(--jd-bg)]">
      <Game />
      <LeaderboardWithWallet />
      <Toaster position="top-center" richColors />
    </div>
  );
}
